module.exports = __webpack_public_path__ + "static/media/carBatteryIcon.c27ec307.svg";